module.exports = __webpack_public_path__ + "img/artesania.8f723489.jpg";